/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestRequestFileSearchResult } from './APIGuestRequestFileSearchResult';
import {
    APIGuestRequestFileSearchResultFromJSON,
    APIGuestRequestFileSearchResultFromJSONTyped,
    APIGuestRequestFileSearchResultToJSON,
} from './APIGuestRequestFileSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIGuestRequestFileSearchResponse
 */
export interface APIGuestRequestFileSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestFileSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIGuestRequestFileSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIGuestRequestFileSearchResult>}
     * @memberof APIGuestRequestFileSearchResponse
     */
    results: Array<APIGuestRequestFileSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIGuestRequestFileSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIGuestRequestFileSearchResponse interface.
 */
export function instanceOfAPIGuestRequestFileSearchResponse(value: object): value is APIGuestRequestFileSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIGuestRequestFileSearchResponseFromJSON(json: any): APIGuestRequestFileSearchResponse {
    return APIGuestRequestFileSearchResponseFromJSONTyped(json, false);
}

export function APIGuestRequestFileSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestRequestFileSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIGuestRequestFileSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIGuestRequestFileSearchResponseToJSON(value?: APIGuestRequestFileSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIGuestRequestFileSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

